export const fileToDataURL = async (file: File): Promise<string | undefined> => {
  const reader = new FileReader()
  const promise = new Promise<ProgressEvent<FileReader>>((resolve) => {
    reader.onload = resolve
  })
  reader.readAsDataURL(file)
  try {
    const event = await promise
    if (event?.target?.result) {
      let url
      if (typeof event.target.result === 'string') {
        url = event.target.result
      } else {
        const bufView: number[] = []
        new Uint16Array(event.target.result).map((i) => i as number).forEach((i) => bufView.push(i))
        url = String.fromCharCode.apply(null, bufView)
      }
      return url
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}
